import status from "./status";
import * as ActionTypes from "../../actions";

//Updates the status apiCalls data for different api call.
var goalMembersTabApiCalls = {
  fetchGoalMembersTabByGoalId: status({
    mapActionToKey: function mapActionToKey(action) {
      return [action.goalId, action.balanceInstant].join("-");
    },
    types: [ActionTypes.GET_GOALMEMBERSTABBYGOALID_REQUEST, ActionTypes.GET_GOALMEMBERSTABBYGOALID_SUCCESS, ActionTypes.GET_GOALMEMBERSTABBYGOALID_FAILURE, ActionTypes.RESET_GET_GOALMEMBERSTABBYGOALID]
  })
};
export default goalMembersTabApiCalls;